import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d5bec0c")

_pushScopeId("data-v-1d5bec0c")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "self-center flex-shrink-0" }
const _hoisted_3 = { class: "ml-3" }
const _hoisted_4 = {
  key: 0,
  class: "list-disc pl-5 space-y-1",
  role: "list"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Dismiss", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")
  const _component_ExclamationIcon = _resolveComponent("ExclamationIcon")
  const _component_XIcon = _resolveComponent("XIcon")

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.alertPadding]
  }, [
    _withDirectives(_createVNode("div", {
      id: _ctx.alertId,
      class: [_ctx.alertPosition, 'rounded-3xl p-4 shadow', _ctx.isError() ? 'bg-red-50' : '', _ctx.isSuccess() ? 'bg-green-50' : '', _ctx.isWarning() ? 'bg-yellow-50' : '', _ctx.isSecondary() ? 'bg-gray-50' : '']
    }, [
      _createVNode("div", _hoisted_1, [
        _withDirectives(_createVNode("div", _hoisted_2, [
          _withDirectives(_createVNode(_component_XCircleIcon, {
            "aria-hidden": "true",
            class: "h-5 w-5 text-red-400"
          }, null, 512), [
            [_vShow, _ctx.isError()]
          ]),
          _withDirectives(_createVNode(_component_CheckCircleIcon, {
            "aria-hidden": "true",
            class: "h-5 w-5 text-green-400"
          }, null, 512), [
            [_vShow, _ctx.isSuccess()]
          ]),
          _withDirectives(_createVNode(_component_ExclamationIcon, {
            "aria-hidden": "true",
            class: "h-5 w-5 text-yellow-400"
          }, null, 512), [
            [_vShow, _ctx.isWarning()]
          ]),
          _withDirectives(_createVNode(_component_ExclamationIcon, {
            "aria-hidden": "true",
            class: "h-5 w-5 text-gray-400"
          }, null, 512), [
            [_vShow, _ctx.isSecondary()]
          ])
        ], 512), [
          [_vShow, _ctx.showIcon]
        ]),
        _createVNode("div", _hoisted_3, [
          _withDirectives(_createVNode("h3", {
            class: ['text-sm font-medium',  _ctx.isError() ? 'text-red-800' : '', _ctx.isSuccess() ? 'text-green-800' : '', _ctx.isWarning() ? 'text-yellow-800' : '', _ctx.isSecondary() ? 'text-gray-800' : '']
          }, _toDisplayString(_ctx.alertTitle), 3), [
            [_vShow, _ctx.showTitle && _ctx.alertTitle.length > 0]
          ]),
          _createVNode("div", {
            class: ['mt-2 text-sm', _ctx.isError() ? 'text-red-700' : '', _ctx.isSuccess() ? 'text-green-700' : '', _ctx.isWarning() ? 'text-yellow-700' : '', _ctx.isSecondary() ? 'text-gray-700' : '']
          }, [
            (_ctx.showAsList)
              ? (_openBlock(), _createBlock("ul", _hoisted_4, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getAllAlerts()[_ctx.alertType], (item) => {
                    return (_openBlock(), _createBlock("li", { key: item }, _toDisplayString(item), 1))
                  }), 128))
                ]))
              : (!_ctx.showAsList && _ctx.hasAlertMessageList !== false)
                ? (_openBlock(), _createBlock("p", _hoisted_5, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getAllAlerts()[_ctx.alertType], (item) => {
                      return (_openBlock(), _createBlock("span", { key: item }, [
                        _createTextVNode(_toDisplayString(item.title), 1),
                        _hoisted_6,
                        _createTextVNode(_toDisplayString(item.message), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_7, _toDisplayString(_ctx.alertMessage), 1))
          ], 2)
        ]),
        _withDirectives(_createVNode("div", {
          class: "ml-auto pl-3",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeAlert(_ctx.alertId)))
        }, [
          _createVNode("div", _hoisted_8, [
            _createVNode("button", {
              class: ['inline-flex focus:ring-2 focus:ring-offset-2 rounded-md p-1.5 focus:outline-none', _ctx.isError() ? 'bg-red-50 text-red-500 hover:bg-red-100 focus:ring-offset-red-50 focus:ring-red-600' : '', _ctx.isSuccess() ? 'bg-green-50 text-green-500 hover:bg-green-100 focus:ring-offset-green-50 focus:ring-green-600' : '', _ctx.isWarning() ? 'bg-yellow-50 text-yellow-500 hover:bg-yellow-100 focus:ring-offset-yellow-50 focus:ring-yellow-600' : '', _ctx.isSecondary() ? 'bg-gray-50 text-gray-500 hover:bg-gray-100 focus:ring-offset-gray-50 focus:ring-gray-600' : ''],
              type: "button"
            }, [
              _hoisted_9,
              _createVNode(_component_XIcon, {
                "aria-hidden": "true",
                class: "h-5 w-5"
              })
            ], 2)
          ])
        ], 512), [
          [_vShow, _ctx.showCloseButton]
        ])
      ])
    ], 10, ["id"]), [
      [_vShow, _ctx.showAlert && _ctx.getAllAlerts() && _ctx.getAllAlerts()[_ctx.alertType] && _ctx.getAllAlerts()[_ctx.alertType].length > 0]
    ])
  ], 2))
})